<button mat-flat-button class="menu" color="basic" [matMenuTriggerFor]="menuLanguage">{{currentLanguage}}<mat-icon>keyboard_arrow_down</mat-icon></button>
<mat-menu #menuLanguage="matMenu" class="language-menu">
    <button mat-menu-item (click)="changeLanguage(language)" *ngFor="let language of supportedLanguages">{{language}}</button>
</mat-menu>